/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import Header from './header';
import UserMenu from './userMenu';
import UserMenuWallet from './userMenuWallet';
import Menu from './menu'
import { staticContentsImagePath as BASE_IMAGE_PATH } from '../configs/const';
import * as _ from 'lodash'
import * as authUtil from "../util/auth.util";
import { getProfileData } from '../services/accountService';
import { DepositBonusOffers, DepositBonusOffersDefault, DepositBonusOffersInfoPopup, DepositOptionsWarningInfoPopup, MINIMUM_DEPOSIT, MINIMUM_WITHDRAW, WithdrawPreviousBank } from '../configs/B2C.config';
import { deleteMyPreviousBank, getBonusOffersDetails, getDepositBonusOffers, getIFSCCodeDetails, getManualWithdrawal, getMyPreviousBank, getXoroActiveProviderData, getXoroDataNew } from '../services/xoroService';
import WalletDepositInnerComp from './walletDepositInnerComp';
import WalletWithdrawInnerComp from './walletWithdrawInnerComp';
import { isJsonString } from '../util/jsoncnvt.util.js';
import PaymentSuccessModal from './sub_components/paymentSuccessModal.js';
import { deleteBeneficiaryAcc, getBeneficiaryAccounts } from '../services/depositWithdrawalService.js';


let socket = null;
class WalletComp extends Component {
    csvLink = React.createRef();
    constructor(props) {
        super(props);
        this.state = {
            pageType: this.props.match.params.type,
            user_id: '',
            userId: '',
            operatorId: '',
            emailId: '',
            mobileNumber: '',
            balance: 0,
            previousBankDetails: null,
            previousBankDetailsBtnLdr: false,
            availableBonusOffers: null,
            bonusOfferApplied: null,
            ifscBankDetails: null,
            xoroDataWithDrawal: {},
            currentWithdrawalType: '',
            curPaymentType: "",
            curAccount: {},
            xoroData: {},
            xoroDataDepositOptions: [],
            xoroDataWithdrawalOptions: [],
            amount: '',
            isMaintanance: false,
            activePG: '',
            activePaymentOption: null,
            mqrImgDt: '',
            showAmountDiv: true,
            loader: false,
            depositDisplayMessage: "",
            withdrawDisplayMessage: "",
            xoroDataDepositOptions: false,
            xoroDataWithdrawalOptions: [],
            minLimitOfDeposit: "",
            maxLimitOfDeposit: "",
            minLimitOfWithdraw: "",
            maxLimitOfWithdraw: "",
            showPopup: false,
            xoroPeSeconds: 0,
            sequence: ["mqr", "PAYWINGS", "WIZPAY", "APEXPAY", "PAYZMENT", "PAYZCART", "DSPAY", "HEROPAY", "STEP2PAY", "ICEPE", "XIENPAY", "bank", "bank", "phonepe", "googlepay", "paytm", "upi", "nagad", "bkash", "rocket", "upay", "crypto", "cash", "whatsapp"],
            pgSequence: { "mqr": 1, "upi": 2, "bank": 3, "crypto": 4, "phonepe": 5, "googlepay": 6, "paytm": 7, "nagad": 8, "bkash": 9, "rocket": 10, "upay": 11, "cash": 12 },
            optionsIconName: {
                "phonepe": { displayName: 'PHONE PE', icon: 'phonepe.png', textDisplay: 'Select wallet - Scan Qr Code - Submit UTR/Transcation ID - Get Your Points.' },
                "googlepay": { displayName: 'GOOGLE PAY', icon: 'gpay.png', textDisplay: 'Select wallet - Scan Qr Code - Submit UTR/Transcation ID - Get Your Points.' },
                "paytm": { displayName: 'PAYTM', icon: 'paytm.png', textDisplay: 'Select wallet - Scan Qr Code - Submit UTR/Transcation ID - Get Your Points.' },
                "upi": { displayName: 'UPI', icon: 'upi.png', textDisplay: 'Select wallet - Scan Qr Code - Submit UTR/Transcation ID - Get Your Points.' },
                "wallet": { displayName: 'WALLET', icon: 'upi.png', textDisplay: 'Select wallet - Scan Qr Code - Submit UTR/Transcation ID - Get Your Points.' },
                "nagad": { displayName: 'NAGAD', icon: 'nagad-icon.png', textDisplay: 'Select Amount - Select Wallet- Transfer Fund To wallet - Submit Sender No./Transcation ID - Get Your Points.' },
                "bkash": { displayName: 'BKASH', icon: 'bkash-icon.png', textDisplay: 'Select Amount - Select Wallet- Transfer Fund To wallet - Submit Sender No./Transcation ID - Get Your Points.' },
                "rocket": { displayName: 'ROCKET', icon: 'rocket-icon.png', textDisplay: 'Select Amount - Select Wallet- Transfer Fund To wallet - Submit Sender No./Transcation ID - Get Your Points.' },
                "upay": { displayName: 'UPAY', icon: 'upay-icon.png', textDisplay: 'Select Amount - Select Wallet- Transfer Fund To wallet - Submit Sender No./Transcation ID - Get Your Points.' },
                "bank": { displayName: 'BANK ACC', icon: 'bank.png', textDisplay: 'Select Amount - Select Bank Account - Transfer Fund To Bank - Submit UTR/Transcation ID - Get Your Points.' },
                "bankpr": { displayName: 'BANK ACC', icon: 'bank.png', textDisplay: 'Select Amount - Select Bank Account - Transfer Fund To Bank - Submit UTR/Transcation ID - Get Your Points.' },
                "Bank": { displayName: 'BANK<br>(100 - Unlimited)', icon: 'bank.png', textDisplay: 'BANK' },
                "crypto": { displayName: 'CRYPTO', icon: 'crypto.png', textDisplay: 'Select wallet - Scan Qr Code - Submit UTR/Transcation ID - Get Your Points.' },
                "mqr": { displayName: 'XOROPE', icon: 'payment_img.png', textDisplay: 'Select Amount - Click Deposit - Scan Qr Code -Pay Thorough Any Wallet Or Bank- Get Your Points.' },
                "cash": { displayName: 'CASH', icon: 'cash.png', textDisplay: 'We Accept Cash through Angadia/Hawala.' },
                "whatsapp": { displayName: 'WHATSAPP', icon: 'whatsapp_img.png', textDisplay: 'Select Amount - Click Deposit - Scan Qr Code - Pay Thorough Any Wallet Or Bank - Get Your Points.' },
                "PAYWINGS": { displayName: "PAYWINGS", icon: 'payment_img.png', textDisplay: 'Select Amount - Click Deposit - Scan Qr Code - Pay Thorough Any Wallet Or Bank - Get Your Points.' },
                "WIZPAY": { displayName: "WIZPAY", icon: 'payment_img.png', textDisplay: 'Select Amount - Click Deposit - Scan Qr Code - Pay Thorough Any Wallet Or Bank - Get Your Points.' },
                "APEXPAY": { displayName: "APEXPAY", icon: 'payment_img.png', textDisplay: 'Select Amount - Click Deposit - Scan Qr Code - Pay Thorough Any Wallet Or Bank - Get Your Points.' },
                "PAYZCART": { displayName: 'payment 10', icon: 'payment_img.png', textDisplay: 'Select Amount - Click Deposit - Scan Qr Code - Pay Thorough Any Wallet Or Bank - Get Your Points.' },
                "PAYZMENT": { displayName: 'PAYZMENT', icon: 'payment_img.png', textDisplay: 'Select Amount - Click Deposit - Scan Qr Code - Pay Thorough Any Wallet Or Bank - Get Your Points.' },
                "DSPAY": { displayName: 'DSPAY', icon: 'payment_img.png', textDisplay: 'Select Amount - Click Deposit - Scan Qr Code - Pay Thorough Any Wallet Or Bank - Get Your Points.' },
                "HEROPAY": { displayName: 'payment 6', icon: 'payment_img.png', textDisplay: 'Select Amount - Click Deposit - Scan Qr Code - Pay Thorough Any Wallet Or Bank - Get Your Points.' },
                "STEP2PAY": { displayName: 'payment 4', icon: 'payment_img.png', textDisplay: 'Select Amount - Click Deposit - Scan Qr Code - Pay Thorough Any Wallet Or Bank - Get Your Points.' },
                "ICEPE": { displayName: 'payment 13', icon: 'payment_img.png', textDisplay: 'Select Amount - Click Deposit - Scan Qr Code - Pay Thorough Any Wallet Or Bank - Get Your Points.' },
                "XIENPAY": { displayName: 'payment 14', icon: 'payment_img.png', textDisplay: 'Select Amount - Click Deposit - Scan Qr Code - Pay Thorough Any Wallet Or Bank - Get Your Points.' },
                "paywings": { displayName: 'PAYWINGS', icon: 'payment_img.png', textDisplay: 'PAYWINGS' },
                "wizpay": { displayName: 'BANK<br>(100 - 5 Lac)', icon: 'payment_img.png', textDisplay: 'BANK (100 - 5 Lac)' },
                "APEXPAY": { displayName: 'APEXPAY', icon: 'payment_img.png', textDisplay: 'APEXPAY' },
                "payzcart": { displayName: 'PAYZCART', icon: 'payment_img.png', textDisplay: 'PAYZCART' },
                "payzment": { displayName: 'payment 3', icon: 'payment_img.png', textDisplay: 'PAYZMENT' },
                "dspay": { displayName: 'DSPAY', icon: 'payment_img.png', textDisplay: 'DSPAY' },
                "heropay": { displayName: 'HEROPAY', icon: 'payment_img.png', textDisplay: 'HEROPAY' },
                "step2pay": { displayName: 'STEP2PAY', icon: 'payment_img.png', textDisplay: 'STEP2PAY' },
                "icepe": { displayName: 'BANK<br>(100 - 50 k)', icon: 'payment_img.png', textDisplay: 'BANK (100 - 50 k)' },
                "xienpay": { displayName: 'BANK<br>(500 - 1 Lac)', icon: 'payment_img.png', textDisplay: 'BANK (500 - 1 Lac)' }
            },
            amountIncrementButton: [100, 500, 1000, 5000, 10000, 100000],
            amountIncrementButtonbkp: [100, 500, 1000, 5000, 10000, 100000],
        };
    }



    componentDidMount() {
        let userData = localStorage.getItem("tokenData")
        userData = JSON.parse(userData)
        if (!(!!userData && !!userData.sub)) {
            authUtil.logout(true);
        }
        socket = this.props.socket;
        this.setState({ user_id: userData.sub }, () => {
            this.componentDidMountTask();
            socket.on("site_room", async (data) => {
                let msg = isJsonString(data);// = JSON.parse(data);
                if (!msg) {
                    return;
                }
                let self = this;
                if (!!msg.command && msg.command === "USER.BALANCE") {
                    let accData = self.state.accountData
                    Object.keys(msg.payload).forEach((elem, i) => {
                        accData[elem] = msg.payload[elem]
                    })
                    if (!!accData.username) {
                        if (accData.userLock) {
                            self.logout()
                        }
                        // self.setState({ accountData: { ...accData } }, () => {
                        let bal = parseFloat(userData.availableBalance);
                        if (!!userData.exposure) {
                            bal = bal + parseFloat(userData.exposure);
                        }
                        if (!!userData.upLineBalance) {
                            bal = bal + parseFloat(userData.upLineBalance);
                        }
                        self.setState({
                            balance: bal.toFixed(2),
                        });
                        // self.setState({ accountData: accData }, () => {
                        //     localStorage.setItem("accountData", JSON.stringify(accData))
                        // })
                        // })
                    }
                }

            });


        })

    }

    componentWillUnmount() {
        const accData = JSON.parse(localStorage.getItem("accountData"));
        // if (!!accData && Object.keys(accData).length > 0) {
        if (!!this.props.socket) {
            this.props.socket.off("site_room");
        }
        // }
    }

    componentDidUpdate(prevProps) {
        if (this.state.pageType !== this.props.match.params.type) {
            this.setState({
                pageType: this.props.match.params.type,
                previousBankDetails: null,
                previousBankDetailsBtnLdr: false,
                availableBonusOffers: null,
                bonusOfferApplied: null,
                ifscBankDetails: null,
                xoroDataWithDrawal: [],
                currentWithdrawalType: '',
                curPaymentType: "",
                curAccount: {},
                xoroData: {},
                xoroDataDepositOptions: false,
                xoroDataWithdrawalOptions: [],
                depositDisplayMessage: "",
                withdrawDisplayMessage: "",
                amount: '',
                activePG: '',
                activePaymentOption: null,
                mqrImgDt: '',
                showAmountDiv: true,
                amountIncrementButton: [100, 500, 1000, 5000, 10000, 100000],
                amountIncrementButtonbkp: [100, 500, 1000, 5000, 10000, 100000],
            }, () => {
                this.componentDidMountTask();
            });
        }
    }

    componentDidMountTask() {

        this.getBalance();
        let profData = JSON.parse(localStorage.getItem('profData'));
        if (this.state.pageType === 'withdraw') {
            if (WithdrawPreviousBank) {
                this.getMyPreviousBankDetails(profData);
            }
            this.getManualWithdrawDetails();
        } else {
            // if (DepositBonusOffers) {
            this.getDepositBonusOffersDetails(profData.operatorId)
            // }
            this.getXoropeDepositDetails();
        }
    }


    getBalance() {
        // accountServices.
        getProfileData(this.state.uid).then((res) => {
            let profData = res;
            let userData = profData;
            profData = JSON.stringify(profData);
            localStorage.setItem("profData", profData);

            // let userData = localStorage.getItem('profData')
            if (!!profData) {
                let bal = parseFloat(userData.availableBalance);
                if (!!userData.exposure) {
                    bal = bal + parseFloat(userData.exposure);
                }
                if (!!userData.upLineBalance) {
                    bal = bal + parseFloat(userData.upLineBalance);
                }
                this.setState({
                    userId: userData.username,
                    operatorId: userData.operatorId,
                    emailId: userData.email,
                    mobileNumber: userData.mobile,
                    balance: bal.toFixed(2),
                    operatorId: userData.operatorId,
                });
            }
        });
    }

    getMyPreviousBankDetails(profData) {
        const self = this;
        let body = { oid: profData.operatorId, user: profData.username };
        // xoroService.
        getBeneficiaryAccounts(body).then((res) => {
            if (!!res && res.isSuccess) {
                if (!!res.data) {
                    self.setState({ previousBankDetails: res.data });
                }
            } else {
                self.props.notify(res?.exception?.message, "error");
            }
        });
    }

    getDepositBonusOffersDetails(oid) {
        const self = this;
        // xoroService.
        // getDepositBonusOffers(oid).then((res) => {
        //     if (!!res && res.isSuccess) {
        //         if (!!res.data) {
        //             self.setState({ availableBonusOffers: res.data.percentage, bonusOfferApplied: (DepositBonusOffersDefault ? (!!res.data.percentage && res.data.percentage !== 0) : false) });
        //         }
        //     } else {
        //         self.props.notify(res?.exception?.message, "error");
        //     }
        // });
        getBonusOffersDetails('DEPOSIT').then((res) => {
            if (!!res && res.isSuccess) {
                if (!!res.data && res.data.length > 0) {
                    let bnsOffrAppld = null;
                    for (let i = 0; i < res.data.length; i++) {
                        if (res.data[i].defaultTick) {
                            bnsOffrAppld = res.data[i].clientBonusId;
                            break;
                        }
                    }
                    self.setState({ availableBonusOffers: res.data, bonusOfferApplied: bnsOffrAppld });
                }
            } else {
                self.props.notify(res?.exception?.message, "error");
            }
        });
    }

    getManualWithdrawDetails() {
        const self = this;
        // xoroService.
        let profData = JSON.parse(localStorage.getItem('profData'));
        let profDataParents = profData?.parents;
        let body = {
            "operatorId": profData?.operatorId,
            "parents": profData?.parents?.reverse()
        }
        this.setState({ loader: true })
        getManualWithdrawal(body).then((res) => {
            
            if (!!res && res.isSuccess) {
                let xoroPeWithDrawOtions = {};
                let withMinLimit = 0;
                let withMaxLimit = 0;
                let checkCondition = true ;
                if (res.data.presetAmounts && res.data.presetAmounts.length > 0) {
                    self.setState({ amountIncrementButton: res.data.presetAmounts })
                    checkCondition  = false
                } else {    
                    self.setState({ amountIncrementButton: self.state.amountIncrementButtonbkp })
                }
                const sortedWithdrawOption = res?.data?.withdrawOptions.sort((a, b) => a.pgSequence - b.pgSequence);
                sortedWithdrawOption?.forEach((item) => {

                    if (withMinLimit === 0) {
                        withMinLimit = item.minLimit;
                    } else if (item.minLimit < withMinLimit) {
                        withMinLimit = item.minLimit;
                    }

                    if (item.maxLimit > withMaxLimit) {
                        withMaxLimit = item.maxLimit;
                    }
                    xoroPeWithDrawOtions[item.pgName] = {
                        gatewayProvider: item,
                        paymentMode: item.pgName,
                        caption: !!item?.caption ? item?.caption : item?.pgName,
                        minMaxCaption: !!item?.minMaxCaption ? item?.minMaxCaption : ""
                    };
                })

                if (xoroPeWithDrawOtions['WhatsApp'] && !!xoroPeWithDrawOtions['WhatsApp'] && xoroPeWithDrawOtions['WhatsApp']?.gatewayProvider?.whatsappData?.length > 0) {
                    xoroPeWithDrawOtions['WhatsApp'] = xoroPeWithDrawOtions['WhatsApp'];
                } else {
                    delete xoroPeWithDrawOtions['WhatsApp']
                }
                //  else {
                //     if (Object.keys(xoroPeWithDrawOtions).includes('whatsappData')) {
                //         delete xoroPeWithDrawOtions['whatsappData']
                //     }
                //     if (Object.keys(xoroPeWithDrawOtions).includes('WhatsApp')) {
                //         delete xoroPeWithDrawOtions['WhatsApp']
                //     }
                // }
                // let xrDtWthDrwl = Object.keys(xoroDataWithDrwl);
                // localStorage.setItem("xoroDataWithDrawal", JSON.stringify(xrDtWthDrwl));
                let showamtsv = true;
                // if (!!profDataParents && profDataParents[profDataParents.length - 1] !== 'admin' && !!xoroPeWithDrawOtions['WhatsApp']) {
                //     const kys = Object.keys(xoroPeWithDrawOtions);
                //     if (!!kys && kys.length > 0) {
                //         kys.forEach((itm) => {
                //             if (itm !== 'WhatsApp') {
                //                 delete xoroPeWithDrawOtions[itm];
                //             }
                //         })
                //         showamtsv = false;
                //     }
                // }

                // else if ((xrpy[itm].gatewayProvider.maxLimit === 0 || this.state.amount <= xrpy[itm].gatewayProvider.maxLimit) && this.state.amount >= xrpy[itm].gatewayProvider.minLimit) {
                //     newObj[itm] = { ...xrpy[itm] }
                // }
                let aIB = this.state.amountIncrementButton;//[100, 500, 1000, 5000, 10000, 100000]
                if(withMinLimit !== 0 && !aIB.includes(withMinLimit) && checkCondition){
                    for(let z=0; z < 4; z++){
                        if(withMinLimit < aIB[z]){
                            aIB[z] = withMinLimit
                            break;
                        }
                    }
                }
                self.setState({ xoroDataWithDrawal: xoroPeWithDrawOtions, showAmountDiv: showamtsv, loader: false, xoroDataWithdrawalOptions: res?.data?.withdrawOptions, minLimitOfWithdraw: withMinLimit, maxLimitOfWithdraw: withMaxLimit, amountIncrementButton: aIB }, () => {
                    let xoroDataWidr = this.returnFilteredWithdrawalOption();
                    if (!!xoroDataWidr && Object.keys(xoroDataWidr).length > 0) {
                        let firstobjvalue = xoroDataWidr[Object.keys(xoroDataWidr)[0]]
                        self.setState({ activePG: Object.keys(xoroPeWithDrawOtions)[0], activePaymentOption: xoroPeWithDrawOtions[Object.keys(xoroDataWidr)[0]] })
                    }
                    // if (!!xoroPeWithDrawOtions && Object.keys(xoroPeWithDrawOtions).length > 0) {
                    //     let firstobjkey = Object.keys(xoroPeWithDrawOtions)[0];
                    //     self.setState({ activePG: firstobjkey, activePaymentOption: xoroPeWithDrawOtions[firstobjkey] })
                    // }
                });
            } else {
                self.setState({ loader: false })
                self.props.notify(res?.exception?.message, "error");
            }
        });
    }

    getXoropeGateWay() {
        const self = this;
        // xoroService.
        getXoroActiveProviderData().then((res) => {
            if (!!res && res.isSuccess) {
                res.data['paymentMode'] = {};
                self.setState({ xoroData: res.data, xoropeDataLoaded: false });
            } else {
                self.props.notify(res?.exception?.message, "error");
            }
        });
    }

    getXoropeDepositDetails() {
        const self = this;
        let profData = JSON.parse(localStorage.getItem('profData'));
        let profDataParents = profData?.parents;
        let body = {
            "operatorId": profData?.operatorId,
            "parents": profData?.parents?.reverse()
        }
        this.setState({ loader: true })
        getXoroDataNew(body).then((res) => {
            if (!!res && res.isSuccess) {
                if(DepositOptionsWarningInfoPopup){
                    this.openDepositOptionsWarningInfoPopup();
                }
                localStorage.setItem("xoroData", JSON.stringify(res.data));
                let xrDataObj = this.state.xoroData;
                let todelete = [];
                let depMinLimit = 0;
                let depMaxLimit = 0;
                let xoroPeOtions = {};
                let checkData = false;
                let checkCondition = true
                if (res.data.presetAmounts && res.data.presetAmounts.length > 0) {
                    this.setState({ amountIncrementButton: res.data.presetAmounts })
                    checkCondition = false
                } else {    
                    self.setState({ amountIncrementButton: self.state.amountIncrementButtonbkp })
                }
                if (!!res.data.pgOptions) {
                    if (!(!!xrDataObj['paymentMode'])) {
                        xrDataObj['paymentMode'] = {};
                    }


                    const sortedOption = res?.data?.pgOptions?.sort((a, b) => a.pgSequence - b.pgSequence)
                    sortedOption?.forEach((item) => {
                        if (item?.pgName !== "XOROPE") {
                            if (!(!!xoroPeOtions['paymentMode'])) {
                                xoroPeOtions['paymentMode'] = {};
                            }

                            xoroPeOtions['paymentMode'][item.pgName] = {
                                gatewayProvider: item,
                                paymentMode: item.pgName,
                                caption: !!item?.caption ? item?.caption : item?.pgName,
                                minMaxCaption: !!item?.minMaxCaption ? item?.minMaxCaption : "",
                                minLimit: item.minLimit
                            };

                            if(!!item.paymentMode && item.paymentMode.length > 0){
                                xoroPeOtions['paymentMode'][item.pgName]['paymentModeOptions'] = item.paymentMode
                            }

                            if (depMinLimit === 0) {
                                depMinLimit = item.minLimit;
                            } else if (item.minLimit < depMinLimit) {
                                depMinLimit = item.minLimit;
                            }
                            if (item.maxLimit > depMaxLimit) {
                                depMaxLimit = item.maxLimit;
                            }
                        } else {
                            xrDataObj['paymentMode'] = res.data.xoropeOptions;
                            Object.keys(xrDataObj['paymentMode']).forEach((itmm) => {
                                if (!!xrDataObj['paymentMode'][itmm] && xrDataObj['paymentMode'][itmm].length > 0) {
                                    let pymntarray = xrDataObj['paymentMode'][itmm];
                                    pymntarray.forEach((ele) => {
                                        ele.gatewayProvider = item?.pgName;
                                        ele.paymentMode = itmm;
                                        ele.caption = itmm === 'mqr' ? (!!item?.caption ? item?.caption : item?.pgName)
                                            : (!!this.state.optionsIconName[itmm] && !!this.state.optionsIconName[itmm].displayName ? this.state.optionsIconName[itmm].displayName : '');
                                        ele.minMaxCaption = (itmm === 'mqr' && !!item?.minMaxCaption) ? item?.minMaxCaption : ""

                                        if (depMinLimit === 0) {
                                            depMinLimit = ele.minLimit;
                                        } else if (ele.minLimit < depMinLimit) {
                                            depMinLimit = ele.minLimit;
                                        }
                                        if (ele.maxLimit > depMaxLimit) {
                                            depMaxLimit = ele.maxLimit;
                                        }
                                        ele.screenshot = itmm === 'mqr' ? false : item.screenshot; 
                                    })
                                    xrDataObj['paymentMode'][itmm] = {
                                        pgSequence: this.state.pgSequence[itmm],
                                        gatewayProvider: item?.pgName,
                                        paymentMode: itmm,
                                        options: [...pymntarray],
                                        caption: itmm === 'mqr' && item?.caption ? item?.caption : (!!this.state.optionsIconName[itmm] && !!this.state.optionsIconName[itmm].displayName ? this.state.optionsIconName[itmm].displayName : item?.pgName),
                                        minMaxCaption: !!itmm?.minMaxCaption ? itmm?.minMaxCaption : ""
                                    }
                                } else {
                                    todelete.push(itmm);
                                }
                            })

                            const sortedXoropeOptions = Object.entries(xrDataObj['paymentMode'])
                                .filter(([_, value]) => Array.isArray(value) ? value.length > 0 : true)
                                .sort((a, b) => (a[1].pgSequence || 0) - (b[1].pgSequence || 0))
                                .reduce((acc, [key, value]) => {
                                    acc[key] = value;
                                    return acc;
                                }, {});

                            xoroPeOtions['paymentMode'] = { ...xoroPeOtions["paymentMode"], ...sortedXoropeOptions }
                        }
                    })

                    if (!!todelete && todelete.length > 0) {
                        todelete.forEach((ite) => {
                            delete xoroPeOtions['paymentMode'][ite];
                        })
                    }

                    if (!!todelete && todelete.length > 0) {
                        todelete.forEach((ite) => {
                            delete xrDataObj[ite];
                        })
                    }
                }

                checkData = !!xoroPeOtions['paymentMode'] && Object.keys(xoroPeOtions['paymentMode'])?.length && Object.keys(xoroPeOtions['paymentMode'])?.length ? true : false;

                let showamtsv = true;
                // if (!!profDataParents && profDataParents[profDataParents.length - 1] !== 'admin' && !!xoroPeOtions['paymentMode'] && !!xoroPeOtions['paymentMode']['whatsapp'] && !!xoroPeOtions['paymentMode']['whatsapp'].options && xoroPeOtions['paymentMode']['whatsapp'].options.length > 0) {
                //     const kys = Object.keys(xoroPeOtions['paymentMode']);
                //     if (!!kys && kys.length > 0) {
                //         kys.forEach((itm) => {
                //             if (itm !== 'whatsapp') {
                //                 delete xoroPeOtions['paymentMode'][itm];
                //             }
                //         })
                //         showamtsv = false;
                //     }
                // }
                let aIB = this.state.amountIncrementButton;//[100, 500, 1000, 5000, 10000, 100000]
                if(depMinLimit !== 0 && !aIB.includes(depMinLimit) && checkCondition){
                    for(let z=0; z < 4; z++){
                        if(depMinLimit < aIB[z]){
                            aIB[z] = depMinLimit
                            break;
                        }
                    }
                }

                if(!!xoroPeOtions && !!xoroPeOtions['paymentMode'] && !!xoroPeOtions['paymentMode']['bank'] && !!xoroPeOtions['paymentMode']['bank']['options'] && xoroPeOtions['paymentMode']['bank']['options'].length > 0){
                    let bnkmin = 0;
                    let bnkmax = 0;

                    xoroPeOtions['paymentMode']['bank']['options'].forEach((itmz, inz)=>{
                        if(!!itmz?.minLimit){
                            bnkmin = bnkmin === 0 ? itmz?.minLimit : (itmz?.minLimit < bnkmin ? itmz?.minLimit : bnkmin);
                        }
                        if(!!itmz?.minLimit){
                            bnkmax = itmz?.maxLimit > bnkmax ? itmz?.maxLimit : bnkmax;
                        }
                    })
                    xoroPeOtions['paymentMode']['bank']['minMaxCaption'] = `(${bnkmin} - ${bnkmax})`;
                }



                self.setState({ xoroData: xoroPeOtions['paymentMode'], showAmountDiv: showamtsv, loading: false, loader: false, xoroDataDepositOptions: checkData, minLimitOfDeposit: depMinLimit, maxLimitOfDeposit: depMaxLimit, amountIncrementButton: aIB }, () => {
                    let xoroDat = this.returnFilteredOptions();
                    if (!!xoroDat && Object.keys(xoroDat).length > 0) {

                        // let firstobjkey = ''; //= Object.keys(xoroDat)[0];
                        // let firstobjvalue = null;// = xoroDat[firstobjkey];
                        // for (let i = 0; i < this.state.sequence.length; i++) {
                        //     if (!!xoroDat[this.state.sequence[i]]) {
                        //         firstobjkey = this.state.sequence[i]
                        //         firstobjvalue = xoroDat[this.state.sequence[i]];
                        //         break;
                        //     }
                        // }
                        let firstobjvalue = xoroDat[Object.keys(xoroDat)[0]]
                        self.setState({ activePG: Object.keys(xoroDat)[0], activePaymentOption: firstobjvalue?.gatewayProvider === "XOROPE" ? firstobjvalue?.options[0] : firstobjvalue })
                    }
                });
            } else {
                self.setState({ loading: false, loader: false })
                self.props.notify(res?.exception?.message, "error");
            }
        });

    }

    parseToPickerDate(date) {
        let dtArr = date.split("/")
        let dt = dtArr[2] + "-" + (dtArr[0].split("").length === 2 ? dtArr[0] : "0" + dtArr[0]) + "-" + (dtArr[1].split("").length === 2 ? dtArr[1] : "0" + dtArr[1])
        return dt
    }

    onChange(e) {
        const name = e.target.name;
        const value = e.target.value;
        if (name === 'amount') {
            if (this.state.pageType === 'deposit') {
                this.setState({ [name]: !!value ? parseInt(value) : '', activePG: '', activePaymentOption: null }, () => {
                    this.filterAfterAmountChange();
                });
            } else if (this.state.pageType === 'withdraw') {
                this.setState({ [name]: !!value ? parseInt(value) : '', activePG: '', activePaymentOption: null }, () => {
                    this.filterAfterAmountChange();
                });
            } else {
                this.setState({ [name]: !!value ? parseInt(value) : '' })
            }
        } else {
            this.setState({ [name]: value });
        }
    }

    amountIncrDecr(multiplier = 1, vl = 1) {
        let amt = this.state.amount;
        if (!(!!amt)) {
            amt = 0;
        }
        amt = amt + (vl * multiplier);
        if (!(amt < 0)) {
            if (this.state.pageType === 'deposit') {
                this.setState({ amount: amt, activePG: '', activePaymentOption: null }, () => {
                    this.filterAfterAmountChange();
                });
            } else if (this.state.pageType === "withdraw") {
                this.setState({ amount: amt, activePG: '', activePaymentOption: null }, () => {
                    this.filterAfterAmountChange();
                });
            } else {
                this.setState({ amount: amt })
            }
        }
    }

    filterAfterAmountChange() {
        if (this.state.pageType === 'deposit') {
            let xoroDat = this.returnFilteredOptions();
            let firstobjvalue = xoroDat[Object.keys(xoroDat)[0]]
            if (this.state.amount === 0 || this.state.amount === "") {
                this.setState({ activePG: Object.keys(xoroDat)[0], activePaymentOption: firstobjvalue?.gatewayProvider === "XOROPE" ? firstobjvalue?.options[0] : firstobjvalue, depositDisplayMessage: "" })
            } else if (this.state.amount >= this.state.minLimitOfDeposit || this.state.minLimitOfDeposit === 0) {
                if (!!xoroDat && Object.keys(xoroDat)?.length > 0) {
                    // let firstobjvalue = xoroDat[Object.keys(xoroDat)[0]]
                    this.setState({ activePG: Object.keys(xoroDat)[0], activePaymentOption: firstobjvalue?.gatewayProvider === "XOROPE" ? firstobjvalue?.options[0] : firstobjvalue, depositDisplayMessage: "" })
                } else {
                    this.setState({ activePG: '', activePaymentOption: null, depositDisplayMessage: `Deposit Limit: Min- ${this.state.minLimitOfDeposit} & Maximum- ${this.state.maxLimitOfDeposit} - Select amount between this range.` })
                }
            } else {
                this.setState({ activePG: !!xoroDat && Object.keys(xoroDat)[0], activePaymentOption: !!firstobjvalue && (firstobjvalue?.gatewayProvider === "XOROPE" ? firstobjvalue?.options[0] : firstobjvalue), depositDisplayMessage: "" })
            }
        } else if (this.state.pageType === "withdraw") {
            let xoroWithData = this.returnFilteredWithdrawalOption();
            let firstobjvalue = xoroWithData[Object.keys(xoroWithData)[0]]
            if (this.state.amount === 0 || this.state.amount === "") {
                this.setState({ activePG: Object.keys(xoroWithData)[0], activePaymentOption: firstobjvalue, withdrawDisplayMessage: "" })
            } else if (this.state.amount >= this.state.minLimitOfWithdraw || this.state.minLimitOfWithdraw === 0) {
                if (!!xoroWithData && Object.keys(xoroWithData)?.length > 0) {
                    // let firstobjvalue = xoroWithData[Object.keys(xoroWithData)[0]]
                    this.setState({ activePG: Object.keys(xoroWithData)[0], activePaymentOption: firstobjvalue, withdrawDisplayMessage: "" })
                } else {
                    this.setState({ activePG: '', activePaymentOption: null, withdrawDisplayMessage: `Withdrawal Limit: Min- ${this.state.minLimitOfWithdraw} & Maximum- ${this.state.maxLimitOfWithdraw} - Select amount between this range.` })
                }
            } else {
                this.setState({ activePG: !!xoroWithData && Object.keys(xoroWithData)[0], activePaymentOption: !!firstobjvalue && firstobjvalue, withdrawDisplayMessage: "" })
            }
        }

    }

    updateMaintanence(status) {
        this.setState({ isMaintanance: status })
    }

    paymentOptionClick(itm) {
        this.setState({ activePaymentOption: itm })
    }

    returnFilteredOptions() {
        let xrpy = { ...this.state.xoroData };
        let newObj = {};
        if (!!xrpy && Object.keys(xrpy).length > 0 && !!this.state.amount && this.state.amount > 0) {
            let keytodel = [];
            Object.keys(xrpy).forEach((itm) => {
                if (xrpy[itm]?.gatewayProvider === "XOROPE") {
                    // let optionsss = xrpy[itm].options.filter((ele) => !(this.state.amount > ele.maxLimit))
                    let optionsss = xrpy[itm].options.filter((ele) =>
                        (ele.minLimit === 0 && ele.maxLimit === 0) ||
                        (this.state.amount >= ele.minLimit && (ele.maxLimit === 0 || this.state.amount <= ele.maxLimit))
                    );
                    if (optionsss.length > 0) {
                        newObj[itm] = { ...xrpy[itm] }
                        newObj[itm].options = [...optionsss];
                    }
                } else if ((xrpy[itm]?.gatewayProvider?.maxLimit === 0 || this.state.amount <= xrpy[itm]?.gatewayProvider.maxLimit) && this.state.amount >= xrpy[itm]?.gatewayProvider?.minLimit) {
                    newObj[itm] = { ...xrpy[itm] }
                }
                // else {
                //     newObj[itm] = { ...xrpy[itm] }
                // }
            })
        } else {
            newObj = xrpy
        }


        return newObj;
    }

    returnFilteredWithdrawalOption() {
        let xrpy = { ...this.state.xoroDataWithDrawal };
        let newObj = {};
        if (!!xrpy && Object.keys(xrpy).length > 0 && !!this.state.amount && this.state.amount > 0) {
            Object.keys(xrpy).forEach((itm) => {
                if ((xrpy[itm]?.gatewayProvider?.maxLimit === 0 || this.state.amount <= xrpy[itm]?.gatewayProvider.maxLimit) && this.state.amount >= xrpy[itm]?.gatewayProvider?.minLimit) {
                    newObj[itm] = { ...xrpy[itm] }
                }
            })
        } else {
            newObj = xrpy
        }
        return newObj;
    }

    onBonusDetailsViewMore(itm) {
        this.props.MySwal.fire({
            title: `<strong>${itm.bonusTitle}</strong>`,
            icon: "",
            html: itm.bonusDetails,
            showCloseButton: true,
        })
        // showCancelButton: true,
        // focusConfirm: false,
        // confirmButtonText: `
        //   <i className="fa fa-thumbs-up"></i> Great!
        // `,
        // confirmButtonAriaLabel: "Thumbs up, great!",
        // cancelButtonText: `
        //   <i className="fa fa-thumbs-down"></i>
        // `,
        // cancelButtonAriaLabel: "Thumbs down"
    }

    // onBonusOfferClick() {
    //     if (this.state.bonusOfferApplied) {
    //         this.setState({ bonusOfferApplied: false });
    //     } else {
    //         if (DepositBonusOffersInfoPopup) {
    //             this.props.MySwal.fire({
    //                 title: "<strong>Bonus Rules</strong>",
    //                 icon: "",
    //                 html: `
    //       <div className="">
    //         <div>
    //           <p className="mb-0 text-black">Minimum 50% Profit loss compulsory & minimum 5 bet different market compulsory.</p>
    //           <p className="mb-0 text-black">Both condition is mandatory</p>
    //           <p className="text-black">Note-  No Bonus No rule</p>
    //         </div>
    //       </div>
    //       `,
    //                 showCloseButton: true,
    //                 showCancelButton: true,
    //                 confirmButtonText: 'Agree'
    //             }).then((result) => {
    //                 /* Read more about isConfirmed, isDenied below */
    //                 if (result.isConfirmed) {
    //                     this.setState({ bonusOfferApplied: true });
    //                 }
    //             });
    //         } else {
    //             this.setState({ bonusOfferApplied: true });
    //         }
    //     }
    // }

    setMqrImgDt(dt) {
        this.setState({ mqrImgDt: dt });
    }

    showPopup(data) {
        this.setState({
            showPopup: data.showPopup,
            xoroPeSeconds: data.xoroPeSeconds
        });
    }

    hideXoroPeTransactionModal = () => {
        this.setState({ showPopup: false, xoroPeSeconds: 0 });
    }

    updatePreviousBankDetails(updatedArray) {
        this.setState({ previousBankDetails: updatedArray });
    };

    // deletePreviousBank(itmm) {
    //     const self = this;
    //     // let profData = JSON.parse(localStorage.getItem('profData'));
    //     // let body = {
    //     //     "operatorId": profData.operatorId,
    //     //     "username": profData.username,
    //     //     "accountNumber": itmm.accountNumber
    //     // }
    //     this.setState({ previousBankDetailsBtnLdr: true }, () => {
    //         deleteBeneficiaryAcc(itmm.beneficiaryId).then((res) => {
    //             if (!!res && res.isSuccess) {
    //                 self.props.notify(res?.data?.message, "success");
    //                 let prvacc = this.state.previousBankDetails.filter((ittm) => ittm.beneficiaryId !== itmm.beneficiaryId);

    //                 // const updatedArray = this.props.array.filter(
    //                 //     (ittm) => ittm.beneficiaryId !== itmm.beneficiaryId
    //                 //   );
    //                 //   // Update the array in the parent component
    //                 //   self.props.updateArray(updatedArray);
    //                 self.setState(
    //                     { previousBankDetails: prvacc, previousBankDetailsBtnLdr: false }
    //                 );
    //             } else {
    //                 self.setState(
    //                     { previousBankDetailsBtnLdr: false }
    //                 );
    //                 self.props.notify(res?.exception?.message, "error");
    //             }
    //         });
    //     })
    // }

    onPGClick(itm, itmValueObject) {
        this.setState({
            activePG: itm,
            activePaymentOption: itmValueObject?.gatewayProvider === "XOROPE" ? itmValueObject?.options[0] : itmValueObject
        }, () => {
            setTimeout(() => {
                requestAnimationFrame(() => {
                    window.scrollTo({
                        top: document.body.scrollHeight,
                        behavior: 'smooth'
                    });
                });
            }, 100);
        });
    }

    onRefreshOptions(type) {
        this.getBalance();
        let profData = JSON.parse(localStorage.getItem('profData'));
        if (type === 'withdraw') {
            if (WithdrawPreviousBank) {
                this.getMyPreviousBankDetails(profData);
            }
            this.getManualWithdrawDetails();
        } else {
            // if (DepositBonusOffers) {
            this.getDepositBonusOffersDetails(profData.operatorId)
            // }
            this.getXoropeDepositDetails();
        }
    }

    goBackToPaymentScreen() {
        if (this.state.pageType === 'deposit') {
            window.location.pathname = '/wallet/deposit'
        } else if (this.state.pageType === 'withdraw') {
            window.location.pathname = "/wallet/withdraw";
        }
    }

    onBonusChange(itm) {
        let bonus = this.state.bonusOfferApplied === itm.clientBonusId ? null : itm.clientBonusId;
        this.setState({ bonusOfferApplied: bonus });
    }

    onBonusOfferClick(itm) {
        if (!!this.state.bonusOfferApplied && this.state.bonusOfferApplied === itm.clientBonusId) {
            this.setState({ bonusOfferApplied: null });
        } else {
            this.props.MySwal.fire({
                title: "<strong>Bonus Rules</strong>",
                icon: "",
                html: itm.bonusDetails,
                showCloseButton: true,
                showCancelButton: true,
                confirmButtonText: 'Agree',
                cancelButtonText: 'Disagree',
                confirmButtonColor: '#28a745',
                cancelButtonColor: '#dc3545'
            }).then((result) => {
                /* Read more about isConfirmed, isDenied below */
                if (result.isConfirmed) {
                    this.setState({ bonusOfferApplied: itm.clientBonusId });
                }
            });
            // if (DepositBonusOffersInfoPopup) {
            // } else {
            //     this.setState({ bonusOfferApplied: itm.clientBonusId });
            // }
        }
    }

    
    openDepositOptionsWarningInfoPopup() {
        this.props.MySwal.fire({
            title: "<strong>Deposit rules</strong>",
            icon: "",
            html: `
      <div class="">
        <div>
          <p class="mb-0 text-black">राशि जमा करने के लिए सिर्फ वेबसाइट पर दिए गए तरीके ही मान्य हैं। अगर पैसे किसी पुराने या गलत खाते में भेजे गए, तो कंपनी जिम्मेदार नहीं होगी।</p>
          <p class="text-light-grey">--------------------------------------------------------</p>
          <p class="mb-0 text-black">Only deposits via listed options are valid. The company isn't liable for funds sent to unlisted or outdated details.</p>
          <p class="text-light-grey">--------------------------------------------------------</p>
          <p class="text-black">
వెబ్‌సైట్‌లో ఇవ్వబడిన పద్ధతులు మాత్రమే నిధులను డిపాజిట్ చేయడానికి చెల్లుబాటు అవుతాయి. పాత లేదా తప్పుడు ఖాతాకు డబ్బు పంపితే కంపెనీ బాధ్యత వహించదు.</p>
        </div>
      </div>
      `,
            showCloseButton: true,
            showCancelButton: true,
            confirmButtonText: 'Agree'
        }).then((result) => {
            /* Read more about isConfirmed, isDenied below */
            
        });
    }

    render() {
        let xoroDat = this.returnFilteredOptions();
        let xoroWid = this.returnFilteredWithdrawalOption();

        const depoUnAvailableOption = this?.state?.pageType === 'deposit' && !this.state.depositDisplayMessage;
        const withUnAvailableOption = this?.state?.pageType === 'withdraw' && !this.state.withdrawDisplayMessage;

        const displayMsg = this?.state?.pageType === 'deposit' ? this?.state?.depositDisplayMessage : (this?.state?.pageType === 'withdraw' ? this?.state?.withdrawDisplayMessage : '');

        const showBackButton = this?.state?.pageType === 'deposit' && !!this?.state?.depositDisplayMessage || this?.state?.pageType === 'withdraw' && !!this?.state?.withdrawDisplayMessage;

        return (
            <div className="radheexch">
                <Header notify={this.props.notify} showSweetAlert={(options) => this.props.showSweetAlert(options)} MySwal={this.props.MySwal} subscribe={(type, id) => { this.props.subscribe(type, id) }} subscriptions={this.props.subscriptions} history={this.props.history} socket={this.props.socket} updateMaintanence={(status) => { this.updateMaintanence(status) }} />
                <div className="full-wrap footerpd">
                    <Menu history={this.props.history} subscribe={(type, id) => { this.props.subscribe(type, id) }} subscriptions={this.props.subscriptions} />
                    <div className="col-centersdetails markets">
                        <div className="mar-top100">
                            <div className="sub_path center-box mt-2">
                                <p>Wallet - {`${this.state.pageType === 'deposit' ? "Deposit" : "Withdraw"}`}
                                    {!this.state.showPopup &&
                                        <button className="ml-1 float-right cursor new_payment_btn_refresh font-bold active" onClick={() => this.onRefreshOptions(this.state.pageType)}>Refresh</button>
                                    }
                                </p>

                            </div>

                            <div className="allreport col3">
                                <div className={`container-fluid wallet-design ${this.state.showPopup ? 'd-none' : ''}`}>
                                    {(this.state.pageType === "deposit" && !!this.state.xoroDataDepositOptions && this?.state?.xoroDataDepositOptions) || (this.state.pageType === "withdraw" && !!this.state.xoroDataWithdrawalOptions && this?.state?.xoroDataWithdrawalOptions?.length > 0) ?
                                        <div className='row pt-2'>
                                            <div className='col-12'>
                                                {/* HEADER */}
                                                <div>
                                                    <div className="mb-1 d-none">
                                                        <span className="payment-methods__form-head-title">
                                                            <img src={`${BASE_IMAGE_PATH}/casino/banner/loginimages/xoropelogo.png`} alt="" /></span>
                                                        <div className="payment-methods__balance">
                                                            <span className="payment-methods__balance-title"> Main Balance</span>
                                                            <span className="payment-methods__balance-value">{this.state.balance}</span>
                                                        </div>
                                                        {/* <div className="d-flex justify-content-end">
                                                            <span className="small text-info"><i className="fa fa-info-circle mr-1"></i>Minimum {this.state.pageType === 'withdraw' ? 'withdraw' : 'deposit'} Amount = {this.state.pageType === 'withdraw' ? MINIMUM_WITHDRAW : MINIMUM_DEPOSIT}.</span>
                                                        </div> */}
                                                    </div>
                                                </div>
                                                {/* END HEADER */}

                                                {/* New Design Payment Deposit Start */}
                                                {
                                                    this.state.pageType === 'deposit' &&
                                                    <>
                                                        <div className=''>
                                                            {/* Deposit Amount Start */}
                                                            {!(!!this.state.mqrImgDt) && this.state.showAmountDiv &&
                                                                <div className='deposit-page'>
                                                                    <div className="deposit-form">
                                                                        <div className="row row5">
                                                                            <div className="col-md-3 col-12">
                                                                                <label className="w-100">Enter Amount:</label>
                                                                                <div className="form-group mb-3 depo-amount">
                                                                                    <button className="deposit-minus" onClick={() => this.amountIncrDecr(-1)}><i className="fas fa-minus"></i></button>
                                                                                    <input type="number" onInput={(e) => {e.target.value = e.target.value.replace(/[^0-9]/g, '');}} placeholder="Amount" className="form-control" name="amount" value={this.state.amount} onChange={(e) => this.onChange(e)} />
                                                                                    <button className="deposit-plus" onClick={() => this.amountIncrDecr()}><i className="fas fa-plus"></i></button>
                                                                                </div>
                                                                            </div>
                                                                            <div className="col-md-9 col-12 mb-1">
                                                                                <label className="w-100 d-none-mobile">&nbsp;</label>
                                                                                <div className="btn-add-container btn-over-scroll">
                                                                                    {
                                                                                        !!this.state.amountIncrementButton && this.state.amountIncrementButton.length > 0 && this.state.amountIncrementButton.map((aib, indx)=>{
                                                                                            return(
                                                                                                <button className="btn btn-sm btn-add" onClick={() => this.amountIncrDecr(1, aib)} key={`${aib}_${indx}`}>+{aib}</button>
                                                                                            )
                                                                                        })
                                                                                    }
                                                                                    {/* <button className="btn btn-sm btn-add" onClick={() => this.amountIncrDecr(1, 100)}>+100</button>
                                                                                    <button className="btn btn-sm btn-add" onClick={() => this.amountIncrDecr(1, 500)}>+500</button>
                                                                                    <button className="btn btn-sm btn-add" onClick={() => this.amountIncrDecr(1, 1000)}>+1000</button>
                                                                                    <button className="btn btn-sm btn-add" onClick={() => this.amountIncrDecr(1, 5000)}>+5000</button>
                                                                                    <button className="btn btn-sm btn-add" onClick={() => this.amountIncrDecr(1, 10000)}>+10000</button>
                                                                                    <button className="btn btn-sm btn-add" onClick={() => this.amountIncrDecr(1, 100000)}>+100000</button> */}
                                                                                </div>
                                                                            </div>
                                                                            {/* OFFER START DepositBonusOffers &&  */}
                                                                            <div className='bonus-x-scroll'>
                                                                                {
                                                                                    !!this.state.availableBonusOffers && this.state.availableBonusOffers.length > 0 && this.state.availableBonusOffers.map((item, i) => {
                                                                                        return (
                                                                                            <div className='w-33' key={`${item.clientBonusId}_${i}`}>
                                                                                                <div className='bonus-card mb-2 '>
                                                                                                    <div className='p-2 pl-3 bonus35'>
                                                                                                        <div className='align-content-center d-flex'>
                                                                                                            <div className="checkbox-wrapper-19">
                                                                                                                <input id={item.clientBonusId} type='checkbox' value={item.clientBonusId} checked={this.state.bonusOfferApplied === item.clientBonusId} onClick={() => this.onBonusOfferClick(item)} />
                                                                                                                <label htmlFor={item.clientBonusId} className="check-box" />
                                                                                                            </div>
                                                                                                            <div className='ml-2 '>
                                                                                                                <h6>Get <span>{item.bonusPercentage}%</span> Bonus</h6>
                                                                                                            </div>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                    <div className='pl-3'>
                                                                                                        <div className='bonus-title-text'>{item.bonusTitle} </div>
                                                                                                    </div>
                                                                                                    <div className='mb-2 pl-3'>
                                                                                                        <div className='bonusviewmore' onClick={() => this.onBonusDetailsViewMore(item)}>T&C</div>
                                                                                                    </div>
                                                                                                </div>

                                                                                            </div>
                                                                                        )
                                                                                    })
                                                                                }</div>

                                                                            {/* <><div className="col-md-3 col-6 mt-2">
                                                                                
                                                                                <div>Available Offer:</div>
                                                                                <label className="" onClick={() => { this.onBonusOfferClick() }}>
                                                                                    <input className="" type="checkbox" checked={this.state.bonusOfferApplied ? 'checked' : ''} />
                                                                                    <span className="">Deposit Bonus {this.state.availableBonusOffers} %</span>
                                                                                </label>
                                                                            </div>
                                                                            <div className="col-md-9 col-6">
                                                                                <a className="bonus-strip-a pull-right" onClick={() => this.onBonusDetailsViewMore()}>Bonus Details</a>
                                                                                
                                                                            </div> </>*/}
                                                                            {/* OFFER END*/}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            }
                                                            {/* Deposit Amount End */}

                                                            {/* new main iteration Start */}
                                                            <>
                                                                {!this.state.depositDisplayMessage ?
                                                                    <div className='new_paymentbg'>
                                                                        {
                                                                            (!!xoroDat && !!Object.keys(xoroDat) && Object.keys(xoroDat).length > 0) && Object.keys(xoroDat)?.map((item, index) => {//Object.keys(xoroDat).map((item, index) => {
                                                                                if ((!!this.state.mqrImgDt && item !== 'mqr') || !(!!xoroDat[item])) {
                                                                                    return false
                                                                                }
                                                                                return (
                                                                                    <button
                                                                                        className={`new_payment_btn font-bold ${this.state.activePG === item ? 'active' : ''
                                                                                            }`}
                                                                                        onClick={() => this.onPGClick(item, xoroDat[item])}
                                                                                        key={`WalletDepositInnerComp_${item}_${index}`}
                                                                                    >
                                                                                        {!!xoroDat[item].caption ? xoroDat[item].caption : ''}
                                                                                        <br />
                                                                                        {!!xoroDat[item].minMaxCaption ? xoroDat[item].minMaxCaption : ""}
                                                                                    </button>
                                                                                )
                                                                            })

                                                                        }
                                                                    </div>
                                                                    :
                                                                    <>
                                                                        <div className='displayMsg-deposit'>
                                                                            {displayMsg && (
                                                                                <div className='mb-2'>{displayMsg}</div>
                                                                            )}
                                                                        </div>
                                                                    </>
                                                                }

                                                                {!!this.state.activePG &&
                                                                    <div className="payment-icon-box-container">
                                                                        <div className="payment-icon-box">
                                                                            <div>
                                                                                <div className='align-items-center d-flex'>
                                                                                    <h4>{this.state.activePaymentOption?.caption}</h4>
                                                                                </div>
                                                                                {!!this.state.activePG && this.state.activePG !== 'whatsapp' &&
                                                                                    <div className='mb-1'>{!!this.state.activePaymentOption?.minMaxCaption ? this.state.activePaymentOption?.minMaxCaption : ""}
                                                                                    </div>
                                                                                    // <div className='mb-2'>{!!this.state.activePaymentOption?.minMaxCaption ? this.state.activePaymentOption?.minMaxCaption : (!!this.state.optionsIconName[this.state.activePG] ? this.state.optionsIconName[this.state.activePG].textDisplay : '')}
                                                                                    // </div>
                                                                                }
                                                                                {(!["mqr", "cash", "whatsapp"].includes(this.state.activePG) && !!xoroDat[this.state.activePG]?.options && xoroDat[this.state.activePG]?.options.length > 0) &&
                                                                                    <div className='d-inline-flex btn-over-scroll'>
                                                                                        {
                                                                                            xoroDat[this.state.activePG].options.map((elle, indx) => {
                                                                                                const tocheckactive = !!elle.accountNumber ? 'accountNumber' : (!!elle.accountNumber ? 'accountNumber' : 'accountNumber')
                                                                                                return (
                                                                                                    <button key={`${this.state.activePG}_${elle[tocheckactive]}_${indx}`} className={`phonepe_btn-grad ${!!this.state.activePaymentOption && !!this.state.activePaymentOption[tocheckactive] && this.state.activePaymentOption[tocheckactive] === elle[tocheckactive] ? 'active' : ''}`} onClick={() => this.paymentOptionClick(elle)}>{!!elle.holderName ? elle.holderName : (!!elle.account_holderName ? elle.account_holderName : elle.name)}</button>
                                                                                                )
                                                                                            })
                                                                                        }
                                                                                    </div>

                                                                                }
                                                                                {/* <div className='d-inline-flex btn-over-scroll'>
                                                                                    <button key={`${this.state.activePG}_${this.state.activePG}_${this.state.activePG}`} className={`phonepe_btn-grad ${!!this.state.activePaymentOption && !!this.state.activePaymentOption[this.state.activePG] && this.state.activePaymentOption[this.state.activePG] === this.state.activePG ? 'active' : ''}`} onClick={() => this.paymentOptionClick(this.state.activePG)}>{xoroDat[this.state.activePG].gatewayProvider !== "XOROPE" ? 'Deposit' : this.state.activePG}</button>
                                                                                </div> */}
                                                                            </div>
                                                                            {
                                                                                (
                                                                                    xoroDat[this.state.activePG]?.gatewayProvider === "XOROPE" && !["mqr", "cash", "whatsapp"].includes(this.state.activePG) &&
                                                                                    (!!this.state.activePaymentOption && this.state.activePaymentOption.paymentMode === this.state.activePG)) && (!!xoroDat && !!Object.keys(xoroDat) && Object.keys(xoroDat).length > 0) &&
                                                                                <WalletDepositInnerComp
                                                                                    key={`deposit_${this.state.activePG}`}
                                                                                    gateWay={this.state.activePG}
                                                                                    activePaymentOption={xoroDat[this.state.activePG]?.gatewayProvider === "XOROPE" ? this.state.activePaymentOption : (["mqr", "cash"].includes(this.state.activePG) && !!xoroDat[this.state.activePG].options && xoroDat[this.state.activePG].options.length > 0 ? xoroDat[this.state.activePG].options[0] : xoroDat[this.state.activePG])}
                                                                                    amount={this.state.amount}
                                                                                    userId={this.state.userId}
                                                                                    emailId={this.state.emailId}
                                                                                    mobileNumber={this.state.mobileNumber}
                                                                                    availableBonusOffers={this.state.availableBonusOffers}
                                                                                    bonusOfferApplied={this.state.bonusOfferApplied}
                                                                                    notify={this.props.notify}
                                                                                    operatorId={this.state.operatorId}
                                                                                    MySwal={this.props.MySwal}
                                                                                    setMqrImgDt={(dt) => this.setMqrImgDt(dt)}
                                                                                    textDisplay={this.state.optionsIconName[this.state.activePG].textDisplay}
                                                                                    socket={this.props.socket}
                                                                                    showPopup={(dta) => this.showPopup(dta)}
                                                                                    showAmountDiv={this.state.showAmountDiv}
                                                                                />
                                                                            }
                                                                            {
                                                                                (["mqr", "cash", "whatsapp"].includes(this.state.activePG) || xoroDat[this.state.activePG]?.gatewayProvider !== "XOROPE") && (!!xoroDat && !!Object.keys(xoroDat) && Object.keys(xoroDat).length > 0) &&
                                                                                <WalletDepositInnerComp
                                                                                    gateWay={this.state.activePG}
                                                                                    activePaymentOption={["mqr", "cash", "whatsapp"].includes(this.state.activePG) && !!xoroDat[this.state.activePG].options && xoroDat[this.state.activePG].options.length > 0 ? xoroDat[this.state.activePG].options[0] : xoroDat[this.state.activePG]}
                                                                                    amount={this.state.amount}
                                                                                    userId={this.state.userId}
                                                                                    emailId={this.state.emailId}
                                                                                    mobileNumber={this.state.mobileNumber}
                                                                                    availableBonusOffers={this.state.availableBonusOffers}
                                                                                    bonusOfferApplied={this.state.bonusOfferApplied}
                                                                                    notify={this.props.notify}
                                                                                    operatorId={this.state.operatorId}
                                                                                    MySwal={this.props.MySwal}
                                                                                    setMqrImgDt={(dt) => this.setMqrImgDt(dt)}
                                                                                    textDisplay={this.state.optionsIconName[this.state.activePG]?.textDisplay}
                                                                                    socket={this.props.socket}
                                                                                    showPopup={(dta) => this.showPopup(dta)}
                                                                                />
                                                                            }
                                                                        </div>
                                                                    </div>
                                                                }
                                                            </>
                                                            {/* new main iteration End */}
                                                        </div>
                                                    </>
                                                }

                                                {/* New Design Payment Deposit End */}



                                                {/* New Design Payment Withdrawal Start */}
                                                {
                                                    this.state.pageType === 'withdraw' &&
                                                    <>
                                                        <div className=''>
                                                            {/* Withdrawal Amount Start */}
                                                            <div className='deposit-page'>
                                                                <div className="deposit-form">
                                                                    {this.state.showAmountDiv &&
                                                                        <div className="row row5">
                                                                            <div className="col-md-3 col-12">
                                                                                <label className="w-100">Enter Amount:</label>
                                                                                <div className="form-group mb-3 depo-amount">
                                                                                    <button className="deposit-minus" onClick={() => this.amountIncrDecr(-1)}><i className="fas fa-minus"></i></button>
                                                                                    <input type="number" onKeyPress={(event) => { return event.charCode >= 48 && event.charCode <= 57 }} placeholder="Amount" className="form-control" name="amount" value={this.state.amount} onChange={(e) => this.onChange(e)} />
                                                                                    <button className="deposit-plus" onClick={() => this.amountIncrDecr()}><i className="fas fa-plus"></i></button>
                                                                                </div>
                                                                            </div>
                                                                            <div className="col-md-9 col-12">
                                                                                <label className="w-100 d-none-mobile">&nbsp;</label>
                                                                                <div className="btn-add-container btn-over-scroll">
                                                                                    {
                                                                                        !!this.state.amountIncrementButton && this.state.amountIncrementButton.length > 0 && this.state.amountIncrementButton.map((aib, indx)=>{
                                                                                            return(
                                                                                                <button className="btn btn-sm btn-add" onClick={() => this.amountIncrDecr(1, aib)} key={`${aib}_${indx}`}>+{aib}</button>
                                                                                            )
                                                                                        })
                                                                                    }
                                                                                    {/* <button className="btn btn-sm btn-add" onClick={() => this.amountIncrDecr(1, 100)}>+100</button>
                                                                                    <button className="btn btn-sm btn-add" onClick={() => this.amountIncrDecr(1, 500)}>+500</button>
                                                                                    <button className="btn btn-sm btn-add" onClick={() => this.amountIncrDecr(1, 1000)}>+1000</button>
                                                                                    <button className="btn btn-sm btn-add" onClick={() => this.amountIncrDecr(1, 5000)}>+5000</button>
                                                                                    <button className="btn btn-sm btn-add" onClick={() => this.amountIncrDecr(1, 10000)}>+10000</button>
                                                                                    <button className="btn btn-sm btn-add" onClick={() => this.amountIncrDecr(1, 100000)}>+100000</button> */}
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    }
                                                                </div>
                                                            </div>
                                                            {/* Withdrawal Amount End */}

                                                            {/* new main iteration Start */}
                                                            <>
                                                                {!this.state.withdrawDisplayMessage ?
                                                                    <div className=' new_paymentbg'>
                                                                        {
                                                                            !!xoroWid && !!Object.keys(xoroWid) && Object.keys(xoroWid).length > 0 && Object.keys(xoroWid).map((item, index) => {
                                                                                return (
                                                                                    <button className={`new_payment_btn font-bold ${this.state.activePG === item ? 'active' : ''}`} onClick={() => this.onPGClick(item, xoroWid[item])} key={`WalletWithdrawInnerComp_${item}_${index}`}>
                                                                                        {!!xoroWid[item].caption ? xoroWid[item].caption : ''}
                                                                                        <br />
                                                                                        {!!xoroWid[item].minMaxCaption ? xoroWid[item].minMaxCaption : ""}
                                                                                    </button>
                                                                                )
                                                                            })
                                                                        }
                                                                    </div>
                                                                    :
                                                                    <>
                                                                        <div className='displayMsg-deposit'>
                                                                            {displayMsg && (
                                                                                <div className='mb-2'>{displayMsg}</div>
                                                                            )}
                                                                        </div>
                                                                    </>
                                                                }
                                                                {!!xoroWid && !!Object.keys(xoroWid) && Object.keys(xoroWid).length > 0 &&
                                                                    <WalletWithdrawInnerComp
                                                                        gateWay={this.state.activePG}
                                                                        iconPath={!!this.state.optionsIconName[this.state.activePG] && !!this.state.optionsIconName[this.state.activePG].icon ? this.state.optionsIconName[this.state.activePG].icon : 'payment_img.png'}
                                                                        displayName={this.state.activePaymentOption?.caption}
                                                                        caption={xoroWid[this.state.activePG]?.minMaxCaption}
                                                                        gatewayProvider={this.state.activePaymentOption?.gatewayProvider?.gatewayProvider}
                                                                        amount={this.state.amount}
                                                                        balance={this.state.balance}
                                                                        userId={this.state.userId}
                                                                        emailId={this.state.emailId}
                                                                        mobileNumber={this.state.mobileNumber}
                                                                        notify={this.props.notify}
                                                                        operatorId={this.state.operatorId}
                                                                        MySwal={this.props.MySwal}
                                                                        previousBankDetails={this.state?.previousBankDetails}
                                                                        previousBankDetailsBtnLdr={this.state.previousBankDetailsBtnLdr}
                                                                        // deletePreviousBank={(itmm) => this.deletePreviousBank(itmm)}
                                                                        updatePreviousBankDetails={(updateArray) => this.updatePreviousBankDetails(updateArray)}
                                                                        MINIMUM_WITHDRAW={MINIMUM_WITHDRAW}
                                                                        activePaymentOption={xoroWid[this.state.activePG]}
                                                                        activeBeneficiaryType={this.state.activePaymentOption?.gatewayProvider?.beneficiaryType}
                                                                        pgName={this.state.activePaymentOption?.gatewayProvider?.pgName}
                                                                    />
                                                                }
                                                            </>
                                                            {/* new main iteration End */}

                                                        </div>
                                                    </>
                                                }
                                                {/* New Design Payment Withdrawal End */}

                                            </div>
                                        </div>
                                        :
                                        <>
                                            {!this.state.loader &&
                                                <>
                                                    <div className='loading-message'>
                                                        {depoUnAvailableOption && (
                                                            <div className='mb-2'> Deposit Payment options are not available right now.</div>
                                                        )}
                                                        {withUnAvailableOption && (
                                                            <div className='mb-2'> Withdrawal Payment options are not available right now.</div>
                                                        )}
                                                    </div>
                                                </>
                                            }
                                        </>
                                    }
                                </div>
                                <div className='container-fluid wallet-design'>
                                    {this.state.showPopup && <PaymentSuccessModal
                                        xoroPeSeconds={this.state.xoroPeSeconds}
                                    />}
                                </div>
                            </div>

                            {/* <div>Payment options is not available right now.</div> */}
                        </div>
                    </div>
                    <div className="col-right wallet-right">
                        <div className="sub_path over-wrap">
                            <div className="center-box wallet-center-box ">
                                <UserMenuWallet history={this.props.history} isMaintanance={this.state.isMaintanance} />
                            </div>
                        </div>
                    </div>
                    {/* <UserMenuMenu history={this.props.history} isMaintanance={this.state.isMaintanance} /> */}
                </div>
            </div>
        )
    }
}
function mapStateToProps(state) {
    return {
    };
}
function mapDispatchToProps(dispatch) {
    return {
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(WalletComp);